import { Col, Empty, Row } from "antd";
import React, { Fragment, useState } from "react";
import { TimeOffTable } from "../TimeOffTable/TimeOffTable.jsx";
import { useWindowDimensions } from "../../../../hooks/useDimensionHook.js";
import { useSelector } from "react-redux";
import { TimeOffListCard } from "../TimesheetListCard/TimeOffListCard.jsx";
import Loader from "../../../../components/Loading/Loader.js";
import { TimesheetConfirmationModal } from "../TimesheetConfirmationModal/TimesheetConfirmationModal.jsx";

const TimeOffTab = ({ handleApproveRejectClick }) => {
  const { width } = useWindowDimensions();
  const timeOffData = useSelector(
    (state) => state.TimeOffReducer.data?.data || []
  );
  const loading = useSelector((state) => state.TimeOffReducer.loading);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleShowReason = (data) => {
    setSelectedData(data);
    setShowReasonModal(true);
  };

  const handleNext = () => {
    setShowReasonModal(false);
    handleApproveRejectClick(selectedData);
  };

  if (loading) return <Loader />;

  return (
    <Fragment>
      <Row style={{marginTop:'10px'}}>
        <Col span={24}>
          {width > 768 ? (
            <TimeOffTable
              handleApproveRejectClick={handleApproveRejectClick}
              handleShowReason={handleShowReason}
            />
          ) : timeOffData?.length ? (
            timeOffData?.map((data) => (
              <TimeOffListCard
                data={data}
                handleApproveRejectClick={handleApproveRejectClick}
                handleShowReason={handleShowReason}
              />
            ))
          ) : (
            <Empty />
          )}
        </Col>
      </Row>
      <TimesheetConfirmationModal
        title="Time Off Reason"
        mainHeading={selectedData?.reason || ""}
        open={showReasonModal}
        handleCancel={() => setShowReasonModal(false)}
        handleApprove={() => handleNext()}
        handleReject={() => handleNext()}
        loading={false}
      />
    </Fragment>
  );
};

export { TimeOffTab };
